export default "__VITE_ASSET__BpySkV_i__"